import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LinkComponent } from './cms-link.component';
import { GenericLinkModule } from '@spartacus/storefront';
import { CmsConfig, provideDefaultConfig } from '@spartacus/core';

@NgModule({
  imports: [CommonModule, RouterModule, GenericLinkModule],
  providers: [
    provideDefaultConfig(<CmsConfig>{
      cmsComponents: {
        CMSLinkComponent: { component: LinkComponent },
      },
    }),
  ],
  declarations: [LinkComponent],
  exports: [LinkComponent],
})
export class CmsLinkModule {}
